"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _index = require("./constants/index");
var _Tickbox = _interopRequireDefault(require("./Tickbox"));
var _TabTrap = _interopRequireDefault(require("./TabTrap"));
var _MultiSelect = _interopRequireDefault(require("./styles/MultiSelect"));
var _shared = _interopRequireDefault(require("./styles/shared"));
var _addOutsideClick = _interopRequireDefault(require("./utils/addOutsideClick"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var EXTRACT_OPTION_INDEX = /^.*-/g;
var OPTION_PREFIX = 'option-';
var ALL_SELECTED_TEXT = 'All Selected';
var MultiSelect = /*#__PURE__*/function (_React$Component) {
  function MultiSelect(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, MultiSelect);
    _this = _callSuper(this, MultiSelect, [props]);
    _this.state = {
      isOpen: false
    };
    _this.removeOutsideListeners = null;
    _this.menuRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleToggleOpen = _this.handleToggleOpen.bind(_this);
    _this.handleToggleClose = _this.handleToggleClose.bind(_this);
    _this.handleSelectAll = _this.handleSelectAll.bind(_this);
    _this.handleOptionChange = _this.handleOptionChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(MultiSelect, _React$Component);
  return (0, _createClass2["default"])(MultiSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!prevState.isOpen && this.state.isOpen) {
        this.removeOutsideListeners = (0, _addOutsideClick["default"])(this.menuRef.current, this.handleToggleClose);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeOutsideListeners && this.removeOutsideListeners();
    }
  }, {
    key: "handleToggleOpen",
    value: function handleToggleOpen(e) {
      if (e.type !== _index.Strings.events.click && !_index.OPEN_KEYS.includes(e.key)) {
        return;
      }
      e.stopPropagation();
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "handleToggleClose",
    value: function handleToggleClose() {
      var _this2 = this;
      this.setState({
        isOpen: false
      }, function () {
        return _this2.removeOutsideListeners && _this2.removeOutsideListeners();
      });
    }
  }, {
    key: "handleSelectAll",
    value: function handleSelectAll() {
      var values = new Set((0, _toConsumableArray2["default"])(this.props.values));
      var options = new Set((0, _toConsumableArray2["default"])(this.props.options.map(function (op) {
        return op.value;
      })));
      var hasAllSelected = values.size === options.size;
      var newValues = hasAllSelected ? [] : (0, _toConsumableArray2["default"])(options.values());
      this.props.onUpdate(newValues, this.props.name);
    }
  }, {
    key: "handleOptionChange",
    value: function handleOptionChange(e) {
      var name = e.target.name;
      var index = Number(name.replace(EXTRACT_OPTION_INDEX, ''));
      var option = this.props.options.find(function (x, i) {
        return i === index;
      });
      var valuesSet = new Set((0, _toConsumableArray2["default"])(this.props.values));
      var hasValue = valuesSet.has(option.value);
      if (hasValue) {
        valuesSet["delete"](option.value);
        this.props.onUpdate((0, _toConsumableArray2["default"])(valuesSet.values()), this.props.name);
      } else {
        valuesSet.add(option.value);
        this.props.onUpdate((0, _toConsumableArray2["default"])(valuesSet.values()), this.props.name);
      }
    }
  }, {
    key: "processValueForDisplay",
    value: function processValueForDisplay() {
      var _this$props = this.props,
        values = _this$props.values,
        options = _this$props.options;
      var length = values.length;
      if (!length) {
        return '';
      } else if (length === 1) {
        return options.find(function (x) {
          return values.includes(x.value);
        }).text;
      } else if (length === options.length) {
        return ALL_SELECTED_TEXT;
      } else {
        return "".concat(length, " selected");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        name = _this$props2.name,
        className = _this$props2.className,
        listClassName = _this$props2.listClassName,
        label = _this$props2.label,
        placeholder = _this$props2.placeholder,
        values = _this$props2.values,
        options = _this$props2.options;
      var multiSelectInput = id;
      var hasAllSelected = values.length === options.length;
      var displayValue = this.processValueForDisplay();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('multi-select', _MultiSelect["default"].multiSelect, className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('multi-select__display', 'has-float-label', 'select-container', _MultiSelect["default"].multiSelect__display, _shared["default"].controlContainer)
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        autoComplete: "off",
        id: multiSelectInput,
        className: "multi-select__input",
        name: name,
        placeholder: placeholder,
        value: displayValue,
        tabIndex: 0,
        readOnly: true,
        onClick: this.handleToggleOpen,
        onKeyDown: this.handleToggleOpen
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: multiSelectInput
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        "aria-hidden": !this.state.isOpen,
        className: (0, _classnames["default"])('multi-select__dropdown-container', {
          'multi-select__dropdown-container--is-open': this.state.isOpen
        }, _MultiSelect["default"].multiSelect__dropdown, this.state.isOpen && _MultiSelect["default"].multiSelect__dropdown_open, listClassName)
      }, /*#__PURE__*/_react["default"].createElement(_TabTrap["default"], {
        ref: this.menuRef,
        element: "ul",
        isActive: this.state.isOpen,
        className: (0, _classnames["default"])('multi-select__list', _MultiSelect["default"].multiSelect__list),
        firstId: "".concat(id, "--selectAll"),
        lastId: "".concat(id, "--").concat(OPTION_PREFIX).concat(options.length - 1),
        onDeactivate: function onDeactivate() {
          var input = document.getElementById(multiSelectInput);
          if (input) {
            input.focus();
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("li", {
        key: "ALL"
      }, /*#__PURE__*/_react["default"].createElement(_Tickbox["default"], {
        id: "".concat(id, "--selectAll"),
        name: "".concat(id, "--selectAll"),
        text: "Select All",
        checked: hasAllSelected,
        onChange: this.handleSelectAll
      })), /*#__PURE__*/_react["default"].createElement("li", {
        key: "SEPARATOR",
        className: (0, _classnames["default"])('multi-select__separator', _MultiSelect["default"].separator)
      }), options.map(function (op, i) {
        var idAndName = "".concat(id, "--").concat(OPTION_PREFIX).concat(i);
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: op.value
        }, /*#__PURE__*/_react["default"].createElement(_Tickbox["default"], {
          id: idAndName,
          name: idAndName,
          text: op.text,
          checked: values.includes(op.value),
          onChange: _this3.handleOptionChange
        }));
      }))));
    }
  }]);
}(_react["default"].Component);
MultiSelect.displayName = 'MultiSelect';
MultiSelect.defaultProps = {
  label: 'MultiSelect',
  placeholder: 'None selected'
};
var _default = exports["default"] = MultiSelect;